module.exports = __webpack_public_path__ + "img/quote-avatar.17a97bab.png";